import { Button } from 'antd';
import { login as config } from '../forms/formConfig';
import { ssFormUtils } from '@bit/ui-common.ui-components/ss-utils';

const 
{ key } = config,
{ generateInitState } = ssFormUtils;

export default class extends React.Component {
    constructor(props) { super(props); }

    shouldDisableLogin(prev) {
        const
        { services, state } = this.props,
        pForm = prev.state.registrationForm[key],
        cLoginButtonDisabled = state.login.loginButtonDisabled,
        cForm = state.registrationForm[key],
        cUsername = cForm.username,
        cUsernameStatus = cForm.username_status,
        cPassword = cForm.password,
        cPasswordStatus = cForm.password_status;

        if (JSON.stringify(pForm) !== JSON.stringify(cForm)) {
            if (
                cUsername.length <= 0 || 
                cPassword.length <= 0 || 
                cUsernameStatus !== 'success' || 
                cPasswordStatus !== 'success'
            ) { if (!cLoginButtonDisabled) services.toggleAfspLoginButtonDisable(); }
            else if (
                cUsername.length > 0 || 
                cPassword.length > 0 || 
                cUsernameStatus === 'success' || 
                cPasswordStatus === 'success'
            ) { if (cLoginButtonDisabled) services.toggleAfspLoginButtonDisable(); }
        }
    }

    componentDidUpdate(prev) {
        this.shouldDisableLogin(prev);
    }

    resetLoginForm() {
        const { services: { storeForm }} = this.props;
        storeForm(key, generateInitState(config));
    }

    render() {
        const { 
            services, 
            state: { 
                registrationForm, 
                login: { 
                    showLoginStatusModal, 
                    loginButtonDisabled, 
                    loginRequest: { status }
                }
            }
        } = this.props;
        return (
            <div>
                <Button
                    size='small'
                    icon='login'
                    type='primary'
                    disabled={status != null ? true : loginButtonDisabled}
                    style={{ width: '120px', borderRadius: '20px', marginRight: '15px' }}
                    onClick={() => {
                        services.toggleAfspLoginStatusModal();
                        services.doAfspLogin(registrationForm[key]);
                    }}
                    id = "loginform login button"
                    aTag = "loginform login button"
                >
                    {'Log In'}
                </Button>
                <Button 
                    size='small'
                    icon='close-circle'
                    type='danger'
                    style={{ width: '120px', borderRadius: '20px' }}
                    onClick={() => {
                        services.toggleAfspLoginModal();
                        setTimeout(() => {
                            this.resetLoginForm();
                            services.resetAfspLoginRequest();
                            services.resetAfspPasswordResetRequest();
                            if (showLoginStatusModal) services.toggleAfspLoginStatusModal();
                        }, 0);
                    }}
                    id = "loginform close button"
                    aTag = "loginform close button"
                >
                    {'Close'}
                </Button>
            </div>
        );
    }
}